import React from "react";
import "./App.css";
import { Route, Routes, BrowserRouter } from "react-router-dom";
import Home from "./Pages/Home";
import Careers from "./Pages/Careers";
import About from "./Pages/About";
import Services from "./Pages/Services";
import WebDevelopment from "../src/Pages/Sub-Pages/WebDevelopment";
import MobileAndDesktop from "../src/Pages/Sub-Pages/MobileAndDesktop";
import B2BMarket from "../src/Pages/Sub-Pages/B2BMarket";
import NotFound from "../src/Pages/NotFound";
import Metaverse from  "../src/Pages/Sub-Pages/Metaverse";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
       { /*Main Routes*/}
          <Route exact path="/" element={<Home/>} />
          <Route path="/careers" element={<Careers/>} />
          <Route path="/about-us" element={<About/>}/>
          <Route path="/services" element={<Services/>}/>
         { /*Sub Routes*/}
           <Route path="/web-development" element={<WebDevelopment/>}/>
          <Route path="/mobile-and-desktop" element={<MobileAndDesktop/>}/>
          <Route path="/virtual-market" element={<B2BMarket/>}/>
          <Route path="/metaverse-tourism" element={<Metaverse/>}/>

          <Route component={NotFound}/>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
